import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f718f74a")

_pushScopeId("data-v-f718f74a")
const _hoisted_1 = { class: "TemplateForm__content" }
const _hoisted_2 = { class: "TemplateForm__MapFooter" }
const _hoisted_3 = { class: "MapFooter__address" }
const _hoisted_4 = { class: "address__description" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Геокодирование при помощи ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Yandex")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("2GIS")
const _hoisted_8 = /*#__PURE__*/_createVNode("p", { class: "address__title" }, "Выбранный адрес:", -1)
const _hoisted_9 = { class: "address__result" }
const _hoisted_10 = { class: "address__text" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Геокодируем адрес... ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Ошибка при поиске адреса ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Поставьте точку на карте или нажмите на иконку склада ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Подтвердить ")
const _hoisted_15 = { class: "content__header" }
const _hoisted_16 = { class: "header__title" }
const _hoisted_17 = { class: "content__form" }
const _hoisted_18 = { class: "form__side" }
const _hoisted_19 = { class: "form__label" }
const _hoisted_20 = {
  class: "form__label",
  style: {"margin-top":"16px"}
}
const _hoisted_21 = { class: "form__side" }
const _hoisted_22 = { class: "form__label" }
const _hoisted_23 = {
  class: "form__address",
  style: {"margin-top":"16px"}
}
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Указать ")
const _hoisted_25 = {
  key: 2,
  style: {"margin-top":"8px"},
  class: "warehouse_message"
}
const _hoisted_26 = { class: "content__actions" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_s_map_search = _resolveComponent("s-map-search")!
  const _component_s_loader = _resolveComponent("s-loader")!
  const _component_icon_location = _resolveComponent("icon-location")!
  const _component_new_button = _resolveComponent("new-button")!
  const _component_s_map = _resolveComponent("s-map")!
  const _component_icon_close = _resolveComponent("icon-close")!
  const _component_s_input = _resolveComponent("s-input")!
  const _component_icon_person = _resolveComponent("icon-person")!
  const _component_s_phone_number = _resolveComponent("s-phone-number")!
  const _component_multiselect = _resolveComponent("multiselect")!
  const _component_s_checkbox = _resolveComponent("s-checkbox")!
  const _component_icon_dots = _resolveComponent("icon-dots")!
  const _component_icon_lattice = _resolveComponent("icon-lattice")!
  const _component_icon_comment = _resolveComponent("icon-comment")!
  const _component_s_text_area = _resolveComponent("s-text-area")!
  const _component_s_modal = _resolveComponent("s-modal")!

  return (_openBlock(), _createBlock(_component_s_modal, {
    class: "TemplateForm",
    onClose: _ctx.onClose
  }, {
    body: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _withDirectives(_createVNode(_component_s_map, {
          onClose: _ctx.closeMap,
          onClick: _ctx.onMapClicked,
          onMapCreated: _ctx.onMapCreated,
          onMapSwitched: _ctx.onMapSwitched
        }, {
          layer: _withId(() => [
            _createVNode(_component_s_map_search, {
              city: _ctx.state.city,
              "geocode-by-yandex": _ctx.map_state.is_yandex || _ctx.map_state.is_google,
              "geocode-by-gis": _ctx.map_state.is_gis,
              onSelect: _ctx.onFindedItemSelect
            }, null, 8, ["city", "geocode-by-yandex", "geocode-by-gis", "onSelect"])
          ]),
          default: _withId(() => [
            _createVNode("div", _hoisted_2, [
              _createVNode("div", _hoisted_3, [
                _createVNode("p", _hoisted_4, [
                  _hoisted_5,
                  _createVNode("b", null, [
                    (_ctx.map_state.is_yandex || _ctx.map_state.is_google)
                      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                          _hoisted_6
                        ], 64))
                      : _createCommentVNode("", true),
                    (_ctx.map_state.is_gis)
                      ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                          _hoisted_7
                        ], 64))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _hoisted_8,
                _createVNode("div", _hoisted_9, [
                  (_ctx.address_state.is_loading)
                    ? (_openBlock(), _createBlock(_component_s_loader, {
                        key: 0,
                        class: "address__icon"
                      }))
                    : (_ctx.address_state.is_finded)
                      ? (_openBlock(), _createBlock(_component_icon_location, {
                          key: 1,
                          class: "address__icon"
                        }))
                      : _createCommentVNode("", true),
                  _createVNode("p", _hoisted_10, [
                    (_ctx.address_state.is_loading)
                      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                          _hoisted_11
                        ], 64))
                      : (_ctx.address_state.is_failed)
                        ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                            _hoisted_12
                          ], 64))
                        : (!_ctx.address_state.is_finded)
                          ? (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
                              _hoisted_13
                            ], 64))
                          : (_openBlock(), _createBlock(_Fragment, { key: 3 }, [
                              (_ctx.address_state.is_warehouse)
                                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(_toDisplayString(_ctx.address_state.address) + " (Склад " + _toDisplayString(_ctx.state.city.name) + ") ", 1)
                                  ], 64))
                                : (_ctx.address_state.is_pvz)
                                  ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                                      _createTextVNode(_toDisplayString(_ctx.address_state.address) + " (ПВЗ: " + _toDisplayString(_ctx.address_state.pvz_name) + ") ", 1)
                                    ], 64))
                                  : (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
                                      _createTextVNode(_toDisplayString(_ctx.address_state.address), 1)
                                    ], 64))
                            ], 64))
                  ])
                ])
              ]),
              _createVNode(_component_new_button, {
                class: "button--primary button--small",
                onClick: _ctx.confirmAddress,
                disabled: !_ctx.address_state.is_finded
              }, {
                default: _withId(() => [
                  _hoisted_14
                ]),
                _: 1
              }, 8, ["onClick", "disabled"])
            ])
          ]),
          _: 1
        }, 8, ["onClose", "onClick", "onMapCreated", "onMapSwitched"]), [
          [_vShow, _ctx.map_state.opened]
        ]),
        (!_ctx.map_state.opened)
          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
              _createVNode("div", _hoisted_15, [
                _createVNode("div", _hoisted_16, _toDisplayString(_ctx.title), 1),
                _createVNode(_component_icon_close, {
                  class: "header__close",
                  onClick: _ctx.onClose
                }, null, 8, ["onClick"])
              ]),
              _createVNode("div", _hoisted_17, [
                _createVNode("div", _hoisted_18, [
                  _createVNode("div", _hoisted_19, _toDisplayString(_ctx.labelOne), 1),
                  _createVNode(_component_s_input, {
                    value: _ctx.state.title,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.title = $event)),
                    class: "template__title",
                    disabled: _ctx.loading,
                    placeholder: _ctx.templateTitlePlaceholder,
                    "is-invalid": _ctx.state_form$.title.$error
                  }, null, 8, ["value", "disabled", "placeholder", "is-invalid"]),
                  _createVNode("div", _hoisted_20, _toDisplayString(_ctx.labelThree), 1),
                  _createVNode(_component_s_input, {
                    value: _ctx.state.full_name,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.full_name = $event)),
                    class: "template__name",
                    placeholder: "Имя и фамилия",
                    disabled: _ctx.loading,
                    "is-invalid": _ctx.state_form$.full_name.$error
                  }, {
                    icon: _withId(() => [
                      _createVNode(_component_icon_person)
                    ]),
                    _: 1
                  }, 8, ["value", "disabled", "is-invalid"]),
                  _createVNode(_component_s_phone_number, {
                    value: _ctx.state.phone,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.phone = $event)),
                    style: {"margin-top":"16px"},
                    placeholder: "Телефон",
                    disabled: _ctx.loading,
                    "is-invalid": _ctx.state_form$.phone.$error
                  }, null, 8, ["value", "disabled", "is-invalid"]),
                  _createVNode(_component_s_phone_number, {
                    value: _ctx.state.additional_phone,
                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.additional_phone = $event)),
                    style: {"margin-top":"16px"},
                    placeholder: "Дополнительный телефон",
                    disabled: _ctx.loading,
                    "is-invalid": _ctx.state_form$.additional_phone.$error
                  }, null, 8, ["value", "disabled", "is-invalid"])
                ]),
                _createVNode("div", _hoisted_21, [
                  _createVNode("div", _hoisted_22, _toDisplayString(_ctx.labelTwo), 1),
                  _createVNode(_component_multiselect, {
                    modelValue: _ctx.state.city,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.state.city = $event)),
                    style: {"margin-top":"16px"},
                    class: { invalid: _ctx.state_form$.city.$error },
                    options: _ctx.data_state.cities.list,
                    disabled: _ctx.loading,
                    object: true,
                    loading: _ctx.data_state.cities.is_loading,
                    label: "name",
                    trackBy: "name",
                    placeholder: "Город",
                    searchable: "",
                    noResultsText: "Ничего не найдено",
                    noOptionsText: "Список пуст",
                    onChange: _ctx.onCityChange
                  }, null, 8, ["modelValue", "class", "options", "disabled", "loading", "onChange"]),
                  (_ctx.isReceiverTemplate)
                    ? (_openBlock(), _createBlock(_component_multiselect, {
                        key: 0,
                        modelValue: _ctx.state.delivery_type,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.state.delivery_type = $event)),
                        style: {"margin-top":"16px"},
                        options: _ctx.DELIVERY_TYPES,
                        object: true,
                        disabled: _ctx.loading,
                        label: "name",
                        trackBy: "name",
                        placeholder: "Тип доставки",
                        searchable: "",
                        noResultsText: "Ничего не найдено",
                        noOptionsText: "Список пуст",
                        onChange: _ctx.onDeliveryTypeChange
                      }, null, 8, ["modelValue", "options", "disabled", "onChange"]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_23, [
                    _createVNode(_component_s_input, {
                      value: _ctx.state.full_address,
                      "is-invalid": _ctx.state_form$.full_address.$error,
                      placeholder: "Адрес",
                      disabled: ""
                    }, {
                      icon: _withId(() => [
                        _createVNode(_component_icon_location)
                      ]),
                      _: 1
                    }, 8, ["value", "is-invalid"]),
                    _createVNode(_component_new_button, {
                      disabled: _ctx.isAddressButtonDisalbed,
                      class: "button--primary button--small",
                      onClick: _ctx.openMap
                    }, {
                      default: _withId(() => [
                        _hoisted_24
                      ]),
                      _: 1
                    }, 8, ["disabled", "onClick"])
                  ]),
                  (_ctx.isRenderingWarehouseCheckbox)
                    ? (_openBlock(), _createBlock(_component_s_checkbox, {
                        key: 1,
                        value: _ctx.data_state.warehouse.is_selected,
                        "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => (_ctx.data_state.warehouse.is_selected = $event)),
                        style: {"margin-top":"16px"},
                        theme: "primary",
                        label: _ctx.templateCheckboxLabel,
                        disabled: _ctx.loading,
                        onChange: _ctx.onToggleWarehouse
                      }, null, 8, ["value", "label", "disabled", "onChange"]))
                    : _createCommentVNode("", true),
                  (_ctx.isRenderingWarehouseCheckboxHint)
                    ? (_openBlock(), _createBlock("p", _hoisted_25, " В выбранном городе склад не найден, пожалуйста выберите другой город "))
                    : _createCommentVNode("", true),
                  (_ctx.isRenderingSenderControls)
                    ? (_openBlock(), _createBlock(_Fragment, { key: 3 }, [
                        _createVNode(_component_s_input, {
                          value: _ctx.state.index,
                          "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => (_ctx.state.index = $event)),
                          style: {"margin-top":"16px"},
                          placeholder: "Индекс",
                          disabled: _ctx.loading,
                          "is-invalid": _ctx.state_form$.index.$error
                        }, {
                          icon: _withId(() => [
                            _createVNode(_component_icon_dots)
                          ]),
                          _: 1
                        }, 8, ["value", "disabled", "is-invalid"]),
                        _createVNode(_component_s_input, {
                          value: _ctx.state.office,
                          "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => (_ctx.state.office = $event)),
                          style: {"margin-top":"16px"},
                          placeholder: "Номер квартиры/офиса",
                          disabled: _ctx.loading,
                          "is-invalid": _ctx.state_form$.office.$error
                        }, {
                          icon: _withId(() => [
                            _createVNode(_component_icon_lattice)
                          ]),
                          _: 1
                        }, 8, ["value", "disabled", "is-invalid"]),
                        _createVNode(_component_s_text_area, {
                          disabled: _ctx.loading,
                          value: _ctx.state.comment,
                          "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => (_ctx.state.comment = $event)),
                          style: {"margin-top":"16px"},
                          placeholder: "Комментарий к адресу"
                        }, {
                          icon: _withId(() => [
                            _createVNode(_component_icon_comment)
                          ]),
                          _: 1
                        }, 8, ["disabled", "value"])
                      ], 64))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode("div", _hoisted_26, [
                _createVNode(_component_new_button, {
                  disabled: _ctx.loading,
                  loading: _ctx.loading,
                  class: "button--primary button--small",
                  onClick: _ctx.onSubmit
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.buttonTitle), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "loading", "onClick"])
              ])
            ], 64))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["onClose"]))
})